var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"saiListContent",staticClass:"sai-list-content"},[_c('ul',{staticClass:"sai-list-content__lists"},_vm._l((_vm.list),function(item,index){return (item)?_c('FaqItem',{key:item.talkScriptId,attrs:{"item":item,"index":index,"action":'frequent'}}):_vm._e()}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae46727","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./products/390/components/Frequent.vue
// module id = asrt
// module chunks = 0